import {apiCall, HttpMethod} from "./index";
import {Archetype, ArchetypeCreation, Callback, User, UserCredits} from "../types/users";
import {BE_ENDPOINT, CHG_ENDPOINT} from "../utils/constants";
import {UserProfileData} from "../types";
import {Paginated, postApplyQuery, QueryParams, Stored} from "../utils/commons";

export async function loggedUser(): Promise<User> {
    const res = await apiCall({
        urlComponent: "/users/current",
        ignoreAuthResponse: true,
    });
    return await res.json();
}

export async function resendEmail() {
    await apiCall({
        urlComponent: `${CHG_ENDPOINT}/users/current:sendVerificationEmail`,
        method: HttpMethod.POST,
    });
}

export async function resetPassword() {
    await apiCall({
        urlComponent: `${CHG_ENDPOINT}/users/current:resetPassword`,
        method: HttpMethod.POST,
    });
}

export async function updateUserProfile(up: UserProfileData) {
    await apiCall({
        urlComponent: `${CHG_ENDPOINT}/users/current`,
        method: HttpMethod.PUT,
        body: up,
    });
}

export async function getUserCredits(): Promise<UserCredits> {
    const res = await apiCall({
        urlComponent: `${BE_ENDPOINT}/users/current/credits`,
    });
    return await res.json();
}

export async function getCallbacks(query: QueryParams<Callback>): Promise<Paginated<Stored<Callback>>> {
    const res = await apiCall({
        urlComponent: `/users/current/callbacks`,
    });
    return postApplyQuery<Callback, Stored<Callback>>(await res.json(), query, ["events", "onlyFinalStatuses", "resourceType", "endpoint"]);
}

export async function deleteCallback(id: string): Promise<void> {
    await apiCall({
        urlComponent: `/users/current/callbacks/${id}`,
        method: HttpMethod.DELETE,
    });
}

export async function createCallback(body: Callback): Promise<void> {
    await apiCall({
        urlComponent: `/users/current/callbacks`,
        method: HttpMethod.POST,
        body
    });
}

export async function getArchetypes(query: QueryParams<Archetype>): Promise<Paginated<Stored<Archetype>>> {
    const res = await apiCall({
        urlComponent: `/archetypes`,
        query,
    });
    return await res.json();
}

export async function createArchetype(body: ArchetypeCreation): Promise<void> {
    await apiCall({
        urlComponent: `/archetypes`,
        method: HttpMethod.POST,
        body
    });
}

export async function deleteArchetype(id: string): Promise<void> {
    await apiCall({
        urlComponent: `/archetypes/${id}`,
        method: HttpMethod.DELETE,
    });
}


